export default "__VITE_ASSET__BsgWjsbo__"